<mat-card appearance="outlined">
  <mat-card-title>Not authenticated</mat-card-title>
  <mat-card-subtitle>
    Oh no, you are not authenticated to see this content!
  </mat-card-subtitle>
  <mat-card-subtitle>
    If you need more privileges, please contact our support
  </mat-card-subtitle>
  <a [href]="'mailto:' + supportMail" mat-button>Send a Mail</a>
</mat-card>
